import { createContext, useContext } from 'react';

import { ReserveCapacityStore } from './reserve-capacity-store';

const ReserveCapacityStoreContext = createContext<ReserveCapacityStore>(undefined as unknown as ReserveCapacityStore);

export const ReserveCapacityStoreProvider = ReserveCapacityStoreContext.Provider;

export const useReserveCapacityStore = () => useContext(ReserveCapacityStoreContext);
